export const APP_STORE_URL =
  "https://apps.apple.com/us/app/progress-step-by-step/id6463463149";

export const PRIVACY_POLICY_URL =
  "https://www.privacypolicygenerator.info/live.php?token=q0cIr4TY8Jx8vVao91jd0xlehoH1zAMy";
